import { Button } from '@svs/ui/react/button';
import Close2 from '@svs/ui/react/icons/Close2';
import type { ReactNode } from 'react';

import type { CouponIndex } from '../../schema/coupon/entry.js';

type DeleteCouponButtonProps = {
  couponIndex: CouponIndex;
};

/**
 * Element containing a button to delete a coupon.
 *
 * @param root0 Object containing the function to delete coupon
 * @param root0.couponIndex Index of the coupon to be deleted
 * @returns JSX.Element
 */
export default function DeleteCouponButton({ couponIndex }: DeleteCouponButtonProps): ReactNode {
  return (
    <Button
      className="text-secondary lg:text-layer-fg z-2 min-w-10 font-medium"
      variant="ghost"
      name="delete"
      type="submit"
      form="coupon_form"
      value={couponIndex}
      aria-label="Ta bort kupong"
    >
      <Close2 />
    </Button>
  );
}
